import { render, staticRenderFns } from "./general-information-edit.vue?vue&type=template&id=0d38e2eb&scoped=true"
import script from "./general-information-edit.vue?vue&type=script&lang=js"
export * from "./general-information-edit.vue?vue&type=script&lang=js"
import style0 from "./general-information-edit.vue?vue&type=style&index=0&id=0d38e2eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38e2eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d38e2eb')) {
      api.createRecord('0d38e2eb', component.options)
    } else {
      api.reload('0d38e2eb', component.options)
    }
    module.hot.accept("./general-information-edit.vue?vue&type=template&id=0d38e2eb&scoped=true", function () {
      api.rerender('0d38e2eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/general-information-edit.vue"
export default component.exports